export default __webpack_public_path__ + "media/images/ico/favicon-76ddb6cfdd26565ef3eecf9c2275175b.ico";